import axios from "axios";
import { authHeaderJson } from "../auth-header.service";



const getAllContracts = () => {
    return axios.get(`/api/contract`, { headers: authHeaderJson() } )
};

const getListContracts = () => {
    return axios.get(`/api/contract/list`, { headers: authHeaderJson() } )
};

const getListContractsProps = () => {
    return axios.get(`/api/contract/contractprop/list`, { headers: authHeaderJson() } )
};

const getListContractPropById = (contractPropId) => {
    return axios.get(`/api/contract/contractproplist/list/${contractPropId}`, { headers: authHeaderJson() } )
};

const getListProps = () => {
    return axios.get(`/api/contract/contractproplist/list`, { headers: authHeaderJson() } )
};

const getContractById = (contractId) => {
    return axios.get(`/api/contract/contract/${contractId}`, { headers: authHeaderJson() } );
};

const addContract = (contract) => {
    return axios.post(`/api/contract/contract/add/`, contract, { headers: authHeaderJson() } );
}
const addContractList = (contracts) => {
    return axios.post(`/api/contract/contract/add/list`, contracts, { headers: authHeaderJson() } );
}
const saveContractById = async (contractId, objContract) => {
    return await axios.put(`/api/contract/contract/update/${contractId}`, objContract, { headers: authHeaderJson() });
};
const deleteContract = (contractId) => {
    return axios.delete(`/api/contract/contract/delete/${contractId}`, { headers: authHeaderJson() });
}

const saveAllContracts = (contractList) => {
    return axios.post(`/api/contract/contract/add/list`, contractList, { headers: authHeaderJson() });
};




const addContractProp = (contractProp) => {
    return axios.post(`/api/contract/contractprop/add`, contractProp, { headers: authHeaderJson() });
};

const updateContractProp = (contractProp) => {
    return axios.put(`/api/contract/contractprop/update/${contractProp.id}`, contractProp, { headers: authHeaderJson() });
};

const deleteContractProp = (contractPropId) => {
    return axios.delete(`/api/contract/contractprop/delete/${contractPropId}`, { headers: authHeaderJson() });
};




const addContractPropValue = (contractPropListValue) => {
    return axios.post(`/api/contract/contractproplist/add`, contractPropListValue, { headers: authHeaderJson() });
};

const updateContractPropValue = (contractPropListValue) => {
    return axios.put(`/api/contract/contractproplist/update/${contractPropListValue.id}`, contractPropListValue, { headers: authHeaderJson() });
};

const deleteContractPropValue = (contractPropListValueId) => {
    return axios.delete(`/api/contract/contractproplist/delete/${contractPropListValueId}`, { headers: authHeaderJson() });
};

export {
    getAllContracts,
    getListContracts,
    getListContractsProps,
    getListContractPropById,
    getListProps,
    getContractById,
    addContract,
    addContractList,
    saveContractById,
    saveAllContracts,
    addContractProp,
    updateContractProp,
    deleteContractProp,
    addContractPropValue,
    updateContractPropValue,
    deleteContractPropValue,
    deleteContract
}